<script lang="ts" setup>
    import { useDisplay, useTheme } from 'vuetify';
    import { useI18n } from 'vue-i18n';
    import { Platform } from '@/constants';
    import { IMenuItem } from '@/types';
    import { getPlatform } from '@/helpers/getPlatform';

    const props = defineProps({
        items: {
            type: Array as () => IMenuItem[],
            default: () => [],
        },
    });

    // const menuStore = useMenuStore();
    const theme = useTheme();
    const display = useDisplay();
    const route = useRoute();
    const { t } = useI18n();

    // const selection = computed<Record<string, any>>({
    //     get: () => menuStore.selection,
    //     set: (value: Record<string, any>) => {
    //         menuStore.selection = value;
    //     },
    // });

    // const clear = (): void => {
    //     selection.value = [];
    // };

    onMounted((): void => {
        console.log('Component app-menuHelp mounted.');
    });
</script>
<template>
    <v-menu offset-y open-delay="100">
        <template v-slot:activator="{ props }">
            <v-btn tag="a" class="link-menu mr-0" :height="display.xs.value ? 30 : 46" min-width="30" :width="display.xs.value ? 30 : 50" variant="text" v-bind="props">
                <v-icon size="24" :color="theme.name.value === 'dark' ? '' : '#867878'" :icon="mdiHelpCircleOutline" />
            </v-btn>
        </template>

        <v-list class="pa-1 rounded" nav>
            <!--            <v-list-item-group v-model="selection['help']">-->
            <div v-for="item in props.items" :key="item.title" class="pb-1" style="height: 36px">
                <router-link :to="{ name: item.link }" class="">
                    <v-list-item :class="[item.link === route.name ? 'v-item--active v-list-item--active' : '']" density="compact" style="min-height: 32px">
                        <!--                            <v-list-item-content class="">-->
                        <v-list-item-title class="font-weight-medium help-menu">
                            {{ t('menu.' + item.title) }}
                        </v-list-item-title>
                        <!--                            </v-list-item-content>-->
                    </v-list-item>
                </router-link>
            </div>
            <!--            <a v-if="getPlatform() !== Platform.Tradeball && locale === 'pt'" class="cursorPointer" href="https://www.youtube.com/@Tradeball" target="“_blank”">-->
            <!--                <v-list-item density="compact" class="mb-1" style="min-height: 32px">-->
            <!--                    &lt;!&ndash;                        <v-list-item-content class="">&ndash;&gt;-->
            <!--                    <v-list-item-title class="font-weight-medium help-menu">-->
            <!--                        <v-img contain :src="'/images/youtube.png'" width="25" height="25"></v-img>-->
            <!--                    </v-list-item-title>-->
            <!--                    &lt;!&ndash;                        </v-list-item-content>&ndash;&gt;-->
            <!--                </v-list-item>-->
            <!--            </a>-->
            <a v-if="getPlatform() === Platform.Tradeball" class="cursorPointer" href="mailto:support@tradeball.com">
                <v-list-item density="compact" class="mb-1" style="min-height: 32px">
                    <!--                        <v-list-item-content class="">-->
                    <v-list-item-title class="font-weight-medium help-menu">
                        {{ t('menu.support') }}
                    </v-list-item-title>
                    <!--                        </v-list-item-content>-->
                </v-list-item>
            </a>
            <!--            </v-list-item-group>-->
        </v-list>
    </v-menu>
</template>
<style scoped>
    .v-theme--light .help-menu {
        color: black;
    }

    .v-theme--dark .help-menu {
        color: #f0f0f0;
    }

    .v-list-item--nav .v-list-item-title {
        font-size: 13px;
    }

    .v-list-item--nav.v-list-item--active {
        background-color: #f5f5f5;
    }

    .v-theme--dark .v-list-item--nav.v-list-item--active {
        background-color: #494b51;
    }

    .v-menu > .v-overlay__content > .v-theme--dark.v-card,
    .v-menu > .v-overlay__content > .v-theme--dark.v-sheet,
    .v-menu > .v-overlay__content > .v-theme--dark.v-list {
        background: #2b2d31;
    }

    .v-theme--light .v-list-item--nav.v-list-item:hover {
        background-color: #fcfcfc;
    }

    .v-theme--dark .v-list-item--nav.v-list-item:hover {
        background-color: #35373b;
    }
</style>
